import { render } from "./SoftSelect.vue?vue&type=template&id=a45ad9c4&scoped=true"
import script from "./SoftSelect.vue?vue&type=script&lang=js"
export * from "./SoftSelect.vue?vue&type=script&lang=js"

import "./SoftSelect.vue?vue&type=style&index=0&id=a45ad9c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45ad9c4"]])

export default __exports__